import { APP_CURRENCY } from './constants/currency';
import { formatDecimal } from './localeNumber';

export const formatCurrency = (value: number): string => {
  const hasDecimals = value % 1 !== 0;
  return `${APP_CURRENCY.symbol}. ${value.toLocaleString(APP_CURRENCY.locale, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
    useGrouping: false,
  })}`;
};

export const formatNumber = (value: number): string => {
  return formatDecimal(value, 0);
};

export const formatPercentage = (value: number): string => {
  return `${value.toFixed(1)}%`;
};

export const formatValue = (
  value: number | string,
  format: 'currency' | 'number' | 'percentage' | 'custom' = 'number',
  customFormatter?: (value: number | string) => string,
): string => {
  if (typeof value === 'string') return value;

  if (format === 'currency') {
    return formatCurrency(value);
  } else if (format === 'number') {
    return formatNumber(value);
  } else if (format === 'percentage') {
    return formatPercentage(value);
  } else if (format === 'custom' && customFormatter) {
    return customFormatter(value);
  }

  return value.toString();
};
